var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 14.6663C2.96645 14.6663 2.66797 14.3679 2.66797 13.9997V1.99967C2.66797 1.63149 2.96645 1.33301 3.33464 1.33301H12.668C13.0362 1.33301 13.3346 1.63149 13.3346 1.99967V13.9997C13.3346 14.3679 13.0362 14.6663 12.668 14.6663H3.33464ZM10.0013 10.6663L13.3346 7.99967L10.0013 5.33301V7.33301H6.0013V8.66634H10.0013V10.6663Z",
    fill: "#8CA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.e2ed52489fba2127d6fcab5ef2ca1cc6.svg";
export { ForwardRef as ReactComponent };